import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    //microdata L'élément <footer> a l'attribut itemScope défini sur http://schema.org/WPFooter pour indiquer qu'il représente un pied de page.
    <footer className="flex" itemScope itemType="http://schema.org/WPFooter">
      <ul
        className="flex"
        itemScope
        itemType="http://schema.org/SiteNavigationElement"
      >
        <li itemProp="name">
          <a href="#About">About</a>
        </li>
        <li itemProp="name">
          <a href="#technologie">Technologie</a>
        </li>
        <li itemProp="name">
          <a href="#project">Projects</a>
        </li>
        <li itemProp="name">
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <p itemProp="copyright">© 2024 Aymane Bouya - All rights reserved.</p>
    </footer>
  );
};

export default Footer;
